import validate from "/home/tom/repros/ongehoord-ui-content/node_modules/.pnpm/nuxt@3.17.4_@parcel+watcher@2.5.1_@types+node@22.15.21_better-sqlite3@11.10.0_db0@0.3.2_bette_jk7j5ejk6iuid2f7dz7fvpcp4a/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/home/tom/repros/ongehoord-ui-content/node_modules/.pnpm/nuxt@3.17.4_@parcel+watcher@2.5.1_@types+node@22.15.21_better-sqlite3@11.10.0_db0@0.3.2_bette_jk7j5ejk6iuid2f7dz7fvpcp4a/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}